import React from "react";

/**
 * LabelPill Component
 * 
 * Props:
 * - name: string (label name)
 * - onRemove: function (callback triggered when dismiss button is clicked)
 * 
 * Renders:
 * - A small rounded rectangle displaying the label name and a dismiss cross button [name ×].
 */
export function LabelPill({ name, onRemove }) {
  return (
    <span className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 rounded-md px-2 py-0.5 text-xs font-medium border border-gray-200 select-none">
      <span>{name}</span>
      <button
        type="button"
        onClick={onRemove}
        className="text-gray-400 hover:text-red-500 font-bold transition-colors duration-150 focus:outline-none leading-none text-sm px-0.5 border-none"
        aria-label={`Remove label ${name}`}
      >
        &times;
      </button>
    </span>
  );
}
